import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';

import { Activity } from '../../features/activity-selector/models';
import { AmountResultFormValue } from './amount-result-form-value';

export interface AmountResultState {
    activity: Activity | undefined;
    amountResult: number | undefined;
}

const initialState: AmountResultState = {
    activity: undefined,
    amountResult: undefined,
};

@Injectable()
export class AmountResultStore extends ComponentStore<AmountResultState> {
    formValues$ = this.select(
        ({ activity, amountResult }): AmountResultFormValue => ({
            activity: activity ?? null,
            amountResult: amountResult?.toString() ?? '',
        }),
    );

    activity$ = this.select((state) => state.activity);

    constructor() {
        super(initialState);
    }

    updateActivityAndAmountResult = this.updater(
        (
            state,
            {
                activity,
                amountResult,
            }: {
                activity: Activity | undefined;
                amountResult: number | undefined;
            },
        ) => {
            if (state.activity?.number === activity?.number && state.amountResult === amountResult) {
                return state;
            }
            return { ...state, activity, amountResult };
        },
    );
}
